export class PromiseBag {
  storage = new Set<PromiseLike<unknown>>();
  add = (promise: PromiseLike<unknown>) => {
    this.storage.add(promise);
  };

  allDone = async () => void (await Promise.all([...this.storage]));
}
